export const mainMenu = [
  {
    title: "Home",
    href: "/",
  },
  // {
  //     title: 'About',
  //     href: '/about'
  // },
  {
    title: "Services",
    href: "/services",
  },
{
  title: "Products",
  href: "/products",
  submenu: [
    { title: "Plywood Boxes and Pallets", href: "/products#plywoodboxesandpallets" },
    { title: "Custom Wood Crates", href: "/products#customwoodcrates" },
    { title: "Heavy-Duty Corrugated (HDC) Packaging Solutions", href: "/products#heavydutycorrugatedhdcpackagingsolutions" },
    { title: "Heavy Machinery Packaging Solutions", href: "/products#heavymachinerypackagingsolutions" },
    { title: "Heavy Duty Wood Skids and Boxes", href: "/products#heavydutywoodskidsandboxes" },
    { title: "Expendable Metal Skids", href: "/products#expendablemetalskids" },
    { title: "Hazardous Goods Packaging", href: "/products#hazardousgoodspackaging" },
    { title: "Paper Pallets", href: "/products#paperpallets" },
    { title: "Equipment Covers", href: "/products#equipmentcovers" },
  ],
},

  // {
  //     title: 'Our Clients',
  //     href: '/case-studies'
  // },

 {
  title: "Pallets",
  href: "/pallets",
  submenu: [
    { title: "Euro Pallets", href: "/pallets#europallets" },
    { title: "Stringer Pallets", href: "/pallets#stringerpallets" },
    { title: "Wooden Pallets", href: "/pallets#woodenpallets" },
    { title: "Wooden Skids", href: "/pallets#woodenskids" },
    { title: "Plastic Pallets", href: "/pallets#plasticpallets" },
    { title: "Metal Pallets", href: "/pallets#metalpallets" },
  ],
},
  {
    title: "Gallery",
    href: "/gallery",
  },
  {
    title: "Contact Us",
    href: "/contact",
  },
];
